import { render } from "./MarkdownContent.vue?vue&type=template&id=66b200ae"
import script from "./MarkdownContent.vue?vue&type=script&lang=js"
export * from "./MarkdownContent.vue?vue&type=script&lang=js"

import "./MarkdownContent.vue?vue&type=style&index=0&id=66b200ae&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__